import { APIEvent } from '../events/apiEvent'
import { StatusBarEvent } from '../events/statusBarEvent'
import { EventBus } from '../event-bus'

export default {
  data () {
    return {
      emailString: '',
      status: '0' // This flag is set by default to 0. API supports enable and disable, but for now we only disable chasers.
    }
  },
  mounted: function () {
    if (window.localStorage.getItem('token') === null) {
      this.$store.dispatch(APIEvent.LOGOUT, {})
    }
  },
  methods: {
    disableInstallChasers: function () {
      if (this.isValid()) {
        let options = {}
        options.status = '0'
        options.email = this.emailString
        this.$store.dispatch(APIEvent.DISABLE_INSTALL_CHASERS, options)
          .then((res) => {
            if (res.data.ack) {
              EventBus.$emit(StatusBarEvent.SUCCESS,
                'Install Chasers have been disabled for this User successfully.')
            }
          })
          .catch(this.handleError)
      }
    },
    isValid: function () {
      let valid = true
      let message = ''
      if (this.emailString === '') {
        message = 'Email address is required'
        valid = false
        this.showValidationWarning(message)
      }
      return valid
    },
    showValidationWarning: function (message) {
      EventBus.$emit(StatusBarEvent.WARNING, message)
    },
    handleError (error) {
      let message = error.message
      switch (error.error) {
        case 205:
          message = 'Email is missing'
          break
        case 209:
          message = 'Email is not in the expected format'
          break
        case 305:
          // Device is not in DB
          message = 'Orders not found for this email address'
          break
        case 306:
          // Error when executing API
          message = 'Unable to disable Install Chaser for this email address'
          break
      }
      error.message = message
      EventBus.$emit(StatusBarEvent.ERROR, error.message)
    }
  }
}
